import ScreenLock from '../__utils/screenLock';
import paginationBuilder from '../__utils/paginationBuilder';

const $ = jQuery.noConflict();

class EventsAjax {
    constructor(page, action) {
        // General
        this.page = $(page);
        this.action = action;
        this.loader = this.page.find('.loader');
        this.eventsContent = this.page.find('.events-content');
        this.eventsWrapper = this.eventsContent.find('.events-cards__cards');
        this.postType = 'tribe_events';
        this.date = this.eventsContent.attr('data-date');

        // Filters
        this.filtersWrapper = this.eventsContent.find('.events-filters');
        this.filterTrigger = this.filtersWrapper.find('.events-filters__filter-trigger');
        this.filterList = this.filtersWrapper.find('.events-filters__filter-list-outer');
        this.filtersInner = this.filtersWrapper.find('.events-filters__inner');

        this.selectedItems = this.filtersWrapper.find('.selected-items');
        this.filtersSelected = this.filtersWrapper.find('.events-filters__selected');
        this.filtersSelectedNumber = this.filtersSelected.find('.events-filters__selected-number');
        this.clearTrigger = this.eventsContent.find('.events-filters__selected-reset');

        this.mobileTrigger = this.eventsContent.find('.events-filters__mobile-trigger');
        this.mobileCloseTrigger = this.eventsContent.find('.events-filters__mobile-close');
        this.mobileSelected = this.eventsContent.find('.events-filters__mobile-selected');
        this.filterInputs = this.filtersInner.find('.events-filters__filter-list-item input[type=checkbox]');

        // Variables
        this.mobileViewport = window.matchMedia('(max-width: 991px)');
        this.transitionTime = 200;
        this.dateIsSelected = parseInt( this.filtersWrapper.find('#date-is-selected').attr('data-value') );

        // Search form
        this.form = this.eventsContent.find('.events-content__search');

        //pagination
        this.pagination = this.eventsContent.find('.pagination-ajax');

        // Data Passed
        this.divisions = [];
        this.sports = [];
        this.event_types = [];

        //Calendar
        this.datepicker =  this.eventsContent.find('.events-datepicker');
        this.currentDay = this.eventsContent.find('.events-cards__day');
    }

    init() {
        if (this.page.length) {
            this.triggerEvents();
            this.addUrlListener();
            this.applyTerms(true);
            this.showSelectedInputs();
            this.initCalendar();
        }
    }

    addUrlListener() {
        window.addEventListener('popstate', function() {
            location.reload(false);
        });
    }

    triggerEvents() {
        // Show mobile filters
        this.mobileTrigger.on('click', (e) => {
            e.preventDefault();
            this.filtersInner.addClass('active');
            ScreenLock.lock();
        });

        // Close mobile filters
        this.mobileCloseTrigger.on('click', (e) => {
            e.preventDefault();
            this.filtersInner.removeClass('active');
            ScreenLock.unlock();
        });



        // // Clear filters
        this.clearTrigger.on('click', (e) => {
            e.preventDefault();
            this.clearFilters();
        });

        // Toggle single filter terms dropdown
        this.filterTrigger.on('click', (e) => {
            e.preventDefault();
            this.toggleFilter(e.delegateTarget);
        });

        // Apply filter term
        this.filterInputs.on('change', () => {
            this.applyTerms();
        });


        //Pagination

       this.pagination.on('click', 'a.page-numbers, a.pagination__arrow', (e) => {
            e.preventDefault();
            this.applyFilters($(e.target).attr('data-page'), this.datepicker.datepicker().val());
        });

        // Submit search form
        this.form.on('submit', (e) => {
            e.preventDefault();
            this.applyTerms();
        });


        // Hide filters on viewport change
        this.mobileViewport.addListener(() => {
            this.filtersInner.removeClass('active');
            this.filterTrigger.removeClass('active');
            this.filterList.removeClass('active').css('display', '');
            ScreenLock.unlock();
        });

    }
    urlParam(name) {
        const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if(results){
            return results[1] || 0;
        } else {
            return null;
        }
    }

    initCalendar() {
        if(this.datepicker){
            this.datepicker.datepicker({
                dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                navigationAsDateFormat: true,
                nextText: 'MM',
                prevText: 'MM',
                showOtherMonths: true,
                dateFormat: "yy-mm-dd",
                selectOtherMonths: true,
                onSelect: (selectdate) => {
                    this.applyFilters(1,selectdate);
                    this.eventsContent.attr('data-date', selectdate);
                    this.date = selectdate;
                    this.datepicker.find(".ui-datepicker-today").parent().addClass('curr-week');
                    this.dateIsSelected = 1;
                    this.showSelectedInputs()
                    setTimeout(() => {
                        this.datepicker.find(".ui-datepicker-today").parent().addClass('curr-week');
                    }, 0);
                },
                onChangeMonthYear: () =>{
                    this.datepicker.find(".ui-datepicker-today").parent().addClass('curr-week');
                    setTimeout(() => {
                        this.datepicker.find(".ui-datepicker-today").parent().addClass('curr-week');
                    }, 0);
                }
            });

            //get parameter
            const date = this.urlParam('date');
            if(date) {
                this.datepicker.datepicker( "setDate", date );
            } else {
                this.datepicker.datepicker('setDate', null).find('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
            }
            //class to current week
            this.datepicker.find(".ui-datepicker-today").parent().addClass('curr-week');
        }
    }


    lockLayout() {
        this.loader.addClass('active');
    }

    unlockLayout() {
        this.loader.removeClass('active');
    }

    toggleFilter(item) {
        const trigger = $(item);
        const list = trigger.next();

        if (trigger.hasClass('active')) {
            if (!this.mobileViewport.matches) list.stop().slideUp(this.transitionTime);
            trigger.removeClass('active');
            list.removeClass('active');
        } else {
            if (!this.mobileViewport.matches) list.stop().slideDown(this.transitionTime);
            trigger.addClass('active');
            list.addClass('active');
        }
    }

    clearFilters() {
        this.filterInputs.prop('checked', false);
        this.datepicker.datepicker('setDate', null).find('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
        this.applyTerms();
    }

    applyTerms(initial) {
        this.sports = [];
        this.divisions = [];
        this.event_types = [];

        //type
        this.filterInputs.filter((i, e) => $(e).data('tax') === 'vi_sport' && $(e).is(':checked')).each((i, e) => {
            this.sports.push($(e).data('id'));
        });

        this.filterInputs.filter((i, e) => $(e).data('tax') === 'vi_school_level' && $(e).is(':checked')).each((i, e) => {
            this.divisions.push($(e).data('id'));
        });

        this.filterInputs.filter((i, e) => $(e).data('tax') === 'vi_event_type' && $(e).is(':checked')).each((i, e) => {
            this.event_types.push($(e).data('id'));
        });


        if ( !initial ) {
            this.applyFilters();
        }
    }

    showSelectedInputs() {
        let checkedInputsNumber = this.filtersInner.find('input[type="checkbox"]:checked').length;
        checkedInputsNumber += this.dateIsSelected;

        if (checkedInputsNumber > 0) {
            this.filtersSelected.addClass('active');
            this.mobileSelected.addClass('active');
            this.filtersSelectedNumber.text( `(${checkedInputsNumber})`);
            this.mobileSelected.text(`${checkedInputsNumber}`);
        } else {
            this.filtersSelected.removeClass('active');
            this.mobileSelected.removeClass('active');
            this.filtersSelectedNumber.text( `(${0})`);
            this.mobileSelected.text('0');
        }

        this.filterTrigger.each((index, el) => {
            const checkedInputsFilter = $(el).parent().find('input[type="checkbox"]:checked').length;
            if(checkedInputsFilter > 0) {
                $(el).find('.selected-items').addClass('active');
                $(el).find('.selected-items').text( `${checkedInputsFilter}`);
            }else{
                $(el).find('.selected-items').removeClass('active');
                $(el).find('.selected-items').text( `${0}`);
            }
        });
    }


    updatePagination(current, max) {
        const page = parseInt(current);
        const max_num_pages = parseInt(max);

        this.pagination.find('.pagination__numbers-wrapper').html(paginationBuilder(this.postType, page, max_num_pages));
        this.pagination.find('.prev').attr('data-page', page - 1);
        this.pagination.find('.next').attr('data-page', page + 1);

        if (page === 1) {
            this.pagination.find('.prev').addClass('disabled');
        } else {
            this.pagination.find('.prev').removeClass('disabled');
        }

        if (page === max_num_pages) {
            this.pagination.find('.next').addClass('disabled');
        } else {
            this.pagination.find('.next').removeClass('disabled');
        }

        if (max_num_pages < 2) {
            this.pagination.addClass('hidden');
        } else {
            this.pagination.removeClass('hidden');
        }
    }


    applyFilters(page = 1, date = '' ) {
        this.lockLayout();

        const dataArr = this.form.serializeArray();
        const term = dataArr[0].value;
        $.ajax({
            type: 'POST',
            url: WP.ajaxUrl,
            dataType: 'JSON',
            data: {
                action: this.action,
                divisions: this.divisions,
                event_types: this.event_types,
                sports: this.sports,
                term,
                date,
                baseUrl: this.eventsContent.attr('data-url'),
                page
            },
        })
        .done((response) => {
            if ( response.url.length ) {
                history.pushState(null, null, response.url);
            } else {
                let clearedUrl = window.location.href.split('?');
                window.history.pushState( {}, null, clearedUrl[0] );
                this.dateIsSelected = 0;
            }
            this.updatePagination(response.page, response.max_num_pages);
            this.showSelectedInputs();
            this.eventsWrapper.html(response.posts_content);
            this.currentDay.text(response.date);

            this.scrollToTop()
        })
        .fail((errorResponse) => {
            console.log('Error: ', errorResponse);
            alert('An error has occurred, please check console for more informations');
        })
        .always(() => {
            this.unlockLayout();
        });
    }

    scrollToTop() {
        $( 'html, body' ).animate({
            scrollTop: this.eventsWrapper.offset().top - 300
        }, 400);
    }
}

const eventsFilters = new EventsAjax('body.post-type-archive-tribe_events', 'applyEventsFilters');

export default eventsFilters;
